import * as React from 'react';
import { Link } from 'react-router-dom';
import WetnotesLogo from './WetnotesLogo';

export interface IFooterProps {
    logged: boolean;
}

class Footer extends React.PureComponent<IFooterProps> {
    static Copyright = 'Copyright © 2018 | WetNotes, s.r.o.';
    static Version = 'v1.0.7-rc.1 (29/05/2018)';

    renderLoggedFooter() {
        return (
            <footer className="footer--logged">
                <div className="footer__holder">
                    <div className="wrapper">
                        <div className="footer__holder__item footer__holder__item--left">
                            <div className="footer__logo">
                                <WetnotesLogo color="black" />
                            </div>
                        </div>

                        <div className="footer__holder__item footer__holder__item--middle">
                            <ul>
                                <li>
                                    <Link
                                        to={{
                                            pathname: '/app/contact',
                                            state: { action: 'contact' }
                                        }}
                                    >
                                        Contact
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={{
                                            pathname: '/app/contact',
                                            state: { action: 'user-agreement' }
                                        }}
                                    >
                                        User Agreement
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to={{
                                            pathname: '/app/contact',
                                            state: { action: 'privacyPolicy' }
                                        }}
                                    >
                                        Privacy Policy
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div className="footer__holder__item footer__holder__item--right hidden">
                            <div className="footer__social">
                                <a className="footer__social__item footer__social__item--twitter">
                                    {' '}
                                </a>
                                <a className="footer__social__item footer__social__item--youtube hidden">
                                    {' '}
                                </a>
                                <a className="footer__social__item footer__social__item--facebook">
                                    {' '}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer__copyright">
                    <p>
                        {Footer.Copyright} | {Footer.Version}
                    </p>
                </div>
            </footer>
        );
    }

    renderUnLoggedFooter() {
        return (
            <footer className="footer--unlogged">
                <div className="footer__holder">
                    <div className="wrapper">
                        <div className="footer__holder__item">
                            <p className="footer__address">
                                <strong>WetNotes, s.r.o.</strong>, reg. ID:
                                05620538, VAT: CZ05620538<br />
                                The company is incorporated in the Commercial
                                Register kept by the Municipal Court in Prague,
                                Czech Republic: C 267499.
                            </p>

                            <a
                                href="mailto:info@divesoft.com"
                                className="footer__email"
                            >
                                info@divesoft.com
                            </a>
                        </div>
                    </div>
                </div>

                <div className="footer__copyright">
                    <p>
                        {Footer.Copyright} | {Footer.Version} |{' '}
                        <Link to="/user-agreement">User Agreement</Link> |{' '}
                        <Link to="/privacy-policy">Privacy Policy</Link>
                    </p>
                </div>
            </footer>
        );
    }

    render() {
        if (this.props.logged) {
            return this.renderLoggedFooter();
        } else {
            return this.renderUnLoggedFooter();
        }
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Footer.tsx